import type { BenchmarkStatus, BucketComparison } from "../../budgetBenchmarks";
import type {
  BenchmarkBucket,
  BenchmarkClassificationAssessment,
} from "../../budgetBucketClassification";

const BUCKET_ORDER: BenchmarkBucket[] = ["atl", "production", "post", "other"];

export function formatBenchmarkDelta(delta: number): string {
  const rounded = Math.round(delta);
  if (rounded === 0) return "0";
  return rounded > 0 ? `+${rounded}` : `${rounded}`;
}

export function getStatusLabel(status: BenchmarkStatus): string {
  if (status === "high") return "High";
  if (status === "low") return "Low";
  return "Typical";
}

export function sortBucketsForDisplay(buckets: BucketComparison[]): BucketComparison[] {
  const outliers = buckets
    .filter((bucket) => bucket.status !== "typical")
    .sort((a, b) => Math.abs(b.deltaFromTypical) - Math.abs(a.deltaFromTypical));
  const typical = buckets
    .filter((bucket) => bucket.status === "typical")
    .sort((a, b) => BUCKET_ORDER.indexOf(a.bucket) - BUCKET_ORDER.indexOf(b.bucket));

  return [...outliers, ...typical];
}

export function getVisibleBenchmarkBuckets(buckets: BucketComparison[]): BucketComparison[] {
  return sortBucketsForDisplay(buckets);
}

export function countOutlierBuckets(buckets: BucketComparison[]): number {
  return buckets.filter((bucket) => bucket.status !== "typical").length;
}

export function getClassificationConfidenceMessage(
  assessment: BenchmarkClassificationAssessment | null | undefined
): string | null {
  if (!assessment || assessment.confidence === "high") return null;

  if (assessment.confidence === "low") {
    return "This budget uses a non-standard chart of accounts. Bucket totals are estimated from category names and account numbers, so treat this comparison as directional.";
  }

  return "Some categories were classified using estimates. Use this comparison as a guide, not a precise verdict.";
}
